/**
 * Returns active scroll children inside scroll container
 * @param {HTMLElement} $scrollEl  - scroll container
 * @param {Array.<Number>} childrenWidthArray - scroll children width in array
 * @param {Number} spaceBetweenChildren - spacing between children in container
 * @return {Number} - index of active scroll children
 */
const getActiveScrollChildrenIndex = ($scrollEl, childrenWidthArray, spaceBetweenChildren) => {
    const containerWidth = $scrollEl.scrollWidth;
    const maxScrollWidth = $scrollEl.scrollWidth - $scrollEl.offsetWidth;
    const currentScrollPosition = $scrollEl.scrollLeft;

    const childrenLimits = childrenWidthArray
        .reduce(
            (acc, childrenWidth) => {
                const widthProcent = Math.floor((childrenWidth + spaceBetweenChildren) * 100/containerWidth);
                const sum = acc.reduce((sumAcc, currentNumber) => sumAcc + currentNumber, 0);
                const limit = sum + Math.floor((widthProcent * maxScrollWidth)/100);
                return [ ...acc, limit ];
            }
        , []);

    for (let childrenKey in childrenLimits) {
        if (currentScrollPosition < childrenLimits[childrenKey]) {
            return Number(childrenKey);
        }
    }
}


export {
    getActiveScrollChildrenIndex
}